import { cssBreakpoints } from "--components/hooks/useBreakpoint";
import { DropTarget } from "--floponents-web/molecules/DropTarget";

import * as React from "react"
import { Slate } from "slate-react";
import styled from "styled-components";
import { BaseElementT } from "../../../../../slate/types";
import { TypedSlateEditableEditor } from "../editors/useTypedEditableEditor";

export const StyledStandaloneSlateInput = styled.div`
    position: relative;
    border: solid 1px ${props => props.theme.palette.ui.border};
    border-radius: ${props => props.theme.radius.large};
    ${cssBreakpoints.mobile} {
        border-radius: ${props => props.theme.radius.small};
    };
    :focus-within {
        border-color: ${props => props.theme.palette.ui.active};
    };
`

export function SlateReactEditor<T extends BaseElementT<any>>(props: React.PropsWithChildren<{ className?: string }> & { editor: TypedSlateEditableEditor<T>, insertFile?: (file: File) => Promise<any> }) {

    return <div className={props.className}><Slate editor={props.editor} value={props.editor.children}>
        {props.insertFile && <DropTarget attachFile={props.insertFile} />}
        {props.children}
    </Slate>
    </div>
}
